import moment from 'moment'
import { useEffect, useState } from 'react'
import PsvApiService from 'services/psvApiService'
import { useWidgetPreview } from '../context/WidgetPreviewContext'
import { MOCK_TIMESTAMP } from '../mocks/statisticsMock'

const DAY_MS = 24 * 60 * 60 * 1000

type PsvPoint = {
	timestamp: number
	psv_value: number
	norm_psv_value: number
}

export const useWidgetPsvDynamicChart = () => {
	const { isPreview } = useWidgetPreview()
	const [psvData, setPsvData] = useState<PsvPoint[]>([])

	useEffect(() => {
		if (isPreview) {
			const endDate = MOCK_TIMESTAMP
			const startDate = endDate - 6 * DAY_MS

			// 7 дневных точек со скачками (большие заломы), но без лишних точек
			const deltas = [0, 4, -2.5, 6, -4, 3, -1.5]
			const base = 24
			const norm = 18

			const mockData: PsvPoint[] = deltas.map((delta, index) => {
				const timestamp = startDate + index * DAY_MS
				const psv_value = base + delta

				return {
					timestamp,
					psv_value,
					norm_psv_value: norm,
				}
			})

			setPsvData(mockData)

			return
		}

		const fetchData = async () => {
			try {
				const endDate = new Date().setHours(0, 0, 0, 0)
				const startDate = moment(endDate).subtract(6, 'days').valueOf()
				const response = await PsvApiService.getPsvDynamicData(
					startDate,
					endDate,
				)
				const graphData = response.data[0].graph
				const formattedData: PsvPoint[] = graphData.map(d => ({
					timestamp: d.timestamp,
					psv_value: d.psv,
					norm_psv_value: d.psv_norm ?? 0,
				}))
				setPsvData(formattedData)
			} catch (error) {
				console.error('Error fetching PSV data', error)
			}
		}

		fetchData()
	}, [isPreview])

	return { psvData }
}
